(ns rothko.icon-animated.component
  (:require [rothko.icon.component :refer [icon]]))

(defn icon-animated
  [{icon-name :icon class :class :as props}]
  [icon (merge props {:class (concat class [:icon-animated (str "icon-animated-" (name icon-name))])})])

(defn spinner
  [props]
  [icon-animated (merge props {:icon :spinner})])

(defn burger-bun
  [props]
  ;; TODO: remove, burger-bun is not actually animated
  [icon-animated (merge props {:icon :bars})])
